module.exports = __webpack_public_path__ + "img/background-ces.9000b157.png";